import { IResult } from '../types/IResponse';
import { Request } from './Request';


export interface IDeleteOrphanedManagedKeychainParams {
  id?: string;
}

export class DeleteOrphanedManagedKeychainRequest extends Request<IDeleteOrphanedManagedKeychainParams, IResult> {
    constructor(params: IDeleteOrphanedManagedKeychainParams) {
      super('deleteOrphanedManagedKeychainsForSite', params);
    }
}